export default __webpack_public_path__ + "static/media/190629_190332_Joe & David 1 JPEG.f017493e.jpg";